import Model from '../../common/models/Model';

export default class VendorCategory extends Model {
  resource() {
    return 'v2/vendor_subcategories';
  }
}
